import { gql } from "apollo-boost";

const GET_PRODUCT_LIST = gql`
  query getProductList($input: GetListInputV1) {
    getProductList(input: $input) {
      status
      error
      data {
        ... on SellerProductListData {
          count
          productList {
            _id
            approved
            compaign
            status
            title
            sku
            updatedAt
            vendor
            vendorId
            images {
              imageUrl
            }
            inventoryManagement
            listingQuantity
            liveConnect {
              platform
            }
            productId
            vendorShopifyProductId
            createdAt
            progressQuantity
            # Only the three fields the row renderer reads: productListView.js uses
            # variants.length and variants[].sku, and the stock badge reads
            # inventoryQuantity / inventoryManagement. Pricing and discount
            # subfields were fetched for every row and never displayed.
            variants {
              sku
              inventoryQuantity
              inventoryManagement
            }
            published
            quantity
            isService
            serviceId
            isDraft
            productDiff
          }
        }
      }
    }
  }
`;
const GET_PRODUCT_LIST_PROVIDER = gql`
  query getProductList($input: GetListInputV1) {
    getProductList(input: $input) {
      status
      error
      data {
        ... on ProductListData {
          count
          productList {
            _id
            approved
            compaign
            createdAt
            images {
              imageUrl
            }
            inventoryManagement
            productId
            status
            title
            sku
            listingQuantity
            liveConnect {
              platform
            }
            updatedAt
            progressQuantity
            variants {
              barcode
              comparePrice
              customRule
              customLabel
              customCharge
              sku
              vendorDiscount {
                price
                type
              }
              inventoryQuantity
              inventoryManagement
            }
            isService
            quantity
            serviceId
            vendor
            vendorId
            vendorShopifyProductId
            isDraft
          }
        }
      }
    }
  }
`;
export { GET_PRODUCT_LIST, GET_PRODUCT_LIST_PROVIDER };
